import {
  SECONDARY_THEME_COLOR,
  BRIGHT_RED,
  LIGHT_GREEN,
  MISTY_ROSE,
  VIBRANT_GREEN,
} from "../../consts/colors";

const styles = {
  toastMessage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "22px",
    width: "100%",
    backgroundColor: SECONDARY_THEME_COLOR,
  },

  commonToastMessage: {
    display: "flex",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "22px",
    width: "100%",
  },

  toastSuccessMessage: {
    backgroundColor: LIGHT_GREEN,
    color: VIBRANT_GREEN,
  },
  toastErrorMessage: {
    backgroundColor: MISTY_ROSE,
    color: BRIGHT_RED,
  },
};

export default styles;
